import React from 'react'
import PrivateRoute from '../auth/PrivateRoute'
import { withRouter } from 'react-router-dom'
import AgentFormPage from './AgentFormPage'
import { findAccessLevel } from '../../modules/accessRoute'
import AgentTableContainer from './AgentTableContainer'

export class AgentPage extends React.Component {
  handleSubmit = () => {
    this.props.history.push(`/agent`)
  }

  table = () => <AgentTableContainer path="/agent" />

  formPage = ({
    match: {
      params: { id },
    },
  }) => <AgentFormPage id={id} onSubmit={this.handleSubmit} />

  render() {
    return (
      <div>
        <PrivateRoute
          exact
          path="/agent"
          component={this.table}
          ifAnyGranted={findAccessLevel('/agent')}
        />

        <PrivateRoute
          path="/agent/new"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/agent')}
        />

        <PrivateRoute
          path="/agent/edit/:id"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/agent')}
        />
      </div>
    )
  }
}

export default withRouter(AgentPage)
